const PROJECT_VIEW_STATE_PREFIX = "projectViewState_";

export const readProjectViewState = (projectId) => {
  if (!projectId) return null;
  try {
    const raw = sessionStorage.getItem(`${PROJECT_VIEW_STATE_PREFIX}${projectId}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const writeProjectViewState = (projectId, state) => {
  if (!projectId) return;
  try {
    sessionStorage.setItem(
      `${PROJECT_VIEW_STATE_PREFIX}${projectId}`,
      JSON.stringify(state),
    );
  } catch {
    /* sessionStorage unavailable — non-fatal */
  }
};
